import { PrizmCountryIsoCode } from '../../enums/country-iso-code';

export const PRIZM_RUSSIAN_LANGUAGE_COUNTRIES: Record<PrizmCountryIsoCode, string> = {
  [PrizmCountryIsoCode.AD]: `Андорра`,
  [PrizmCountryIsoCode.AE]: `Объединенные Арабские Эмираты`,
  [PrizmCountryIsoCode.AF]: `Афганистан`,
  [PrizmCountryIsoCode.AG]: `Антигуа и Барбуда`,
  [PrizmCountryIsoCode.AI]: `Ангилья`,
  [PrizmCountryIsoCode.AL]: `Албания`,
  [PrizmCountryIsoCode.AM]: `Армения`,
  [PrizmCountryIsoCode.AO]: `Ангола`,
  [PrizmCountryIsoCode.AR]: `Аргентина`,
  [PrizmCountryIsoCode.AT]: `Австрия`,
  [PrizmCountryIsoCode.AU]: `Австралия`,
  [PrizmCountryIsoCode.AW]: `Аруба`,
  [PrizmCountryIsoCode.AZ]: `Азербайджан`,
  [PrizmCountryIsoCode.BA]: `Босния и Герцеговина`,
  [PrizmCountryIsoCode.BB]: `Барбадос`,
  [PrizmCountryIsoCode.BD]: `Бангладеш`,
  [PrizmCountryIsoCode.BE]: `Бельгия`,
  [PrizmCountryIsoCode.BF]: `Буркина Фасо`,
  [PrizmCountryIsoCode.BG]: `Болгария`,
  [PrizmCountryIsoCode.BH]: `Бахрейн`,
  [PrizmCountryIsoCode.BI]: `Бурунди`,
  [PrizmCountryIsoCode.BJ]: `Бенин`,
  [PrizmCountryIsoCode.BM]: `Бермудские острова`,
  [PrizmCountryIsoCode.BN]: `Бруней-Даруссалам`,
  [PrizmCountryIsoCode.BO]: `Боливия`,
  [PrizmCountryIsoCode.BQ]: `Бонайре, Синт-Эстатиус и Саба`,
  [PrizmCountryIsoCode.BR]: `Бразилия`,
  [PrizmCountryIsoCode.BS]: `Багамские Острова`,
  [PrizmCountryIsoCode.BT]: `Бутан`,
  [PrizmCountryIsoCode.BW]: `Ботсвана`,
  [PrizmCountryIsoCode.BY]: `Беларусь (Белоруссия)`,
  [PrizmCountryIsoCode.BZ]: `Белиз`,
  [PrizmCountryIsoCode.CA]: `Канада`,
  [PrizmCountryIsoCode.CD]: `Дем. Респ. Конго (Киншаса)`,
  [PrizmCountryIsoCode.CF]: `Центральноафриканская Республика`,
  [PrizmCountryIsoCode.CG]: `Конго (Браззавиль)`,
  [PrizmCountryIsoCode.CH]: `Швейцария`,
  [PrizmCountryIsoCode.CI]: `Кот-д’Ивуар`,
  [PrizmCountryIsoCode.CL]: `Чили`,
  [PrizmCountryIsoCode.CM]: `Камерун`,
  [PrizmCountryIsoCode.CN]: `Китайская Н.Р.`,
  [PrizmCountryIsoCode.CO]: `Колумбия`,
  [PrizmCountryIsoCode.CR]: `Коста-Рика`,
  [PrizmCountryIsoCode.CU]: `Куба`,
  [PrizmCountryIsoCode.CV]: `Кабо-Верде`,
  [PrizmCountryIsoCode.CW]: `Кюрасао`,
  [PrizmCountryIsoCode.CY]: `Кипр`,
  [PrizmCountryIsoCode.CZ]: `Чехия`,
  [PrizmCountryIsoCode.DE]: `Германия`,
  [PrizmCountryIsoCode.DJ]: `Джибути`,
  [PrizmCountryIsoCode.DK]: `Дания`,
  [PrizmCountryIsoCode.DM]: `Доминика`,
  [PrizmCountryIsoCode.DO]: `Доминиканская Республика`,
  [PrizmCountryIsoCode.DZ]: `Алжир`,
  [PrizmCountryIsoCode.EC]: `Эквадор `,
  [PrizmCountryIsoCode.EE]: `Эстония `,
  [PrizmCountryIsoCode.EG]: `Египет`,
  [PrizmCountryIsoCode.ER]: `Эритрея`,
  [PrizmCountryIsoCode.ES]: `Испания`,
  [PrizmCountryIsoCode.ET]: `Эфиопия`,
  [PrizmCountryIsoCode.FI]: `Финляндия`,
  [PrizmCountryIsoCode.FJ]: `Фиджи`,
  [PrizmCountryIsoCode.FK]: `Фолклендские острова`,
  [PrizmCountryIsoCode.FM]: `Ф.Ш. Микронезии`,
  [PrizmCountryIsoCode.FR]: `Франция`,
  [PrizmCountryIsoCode.GA]: `Габон`,
  [PrizmCountryIsoCode.GB]: `Великобритания`,
  [PrizmCountryIsoCode.GD]: `Гренада`,
  [PrizmCountryIsoCode.GE]: `Грузия`,
  [PrizmCountryIsoCode.GH]: `Гана`,
  [PrizmCountryIsoCode.GI]: `Гибралтар`,
  [PrizmCountryIsoCode.GL]: `Гренландия`,
  [PrizmCountryIsoCode.GM]: `Гамбия`,
  [PrizmCountryIsoCode.GN]: `Гвинея`,
  [PrizmCountryIsoCode.GQ]: `Экваториальная Гвинея`,
  [PrizmCountryIsoCode.GR]: `Греция`,
  [PrizmCountryIsoCode.GT]: `Гватемала`,
  [PrizmCountryIsoCode.GW]: `Гвинея-Бисау`,
  [PrizmCountryIsoCode.GY]: `Гайана`,
  [PrizmCountryIsoCode.HK]: `Гонконг`,
  [PrizmCountryIsoCode.HN]: `Гондурас`,
  [PrizmCountryIsoCode.HR]: `Хорватия`,
  [PrizmCountryIsoCode.HT]: `Гаити`,
  [PrizmCountryIsoCode.HU]: `Венгрия`,
  [PrizmCountryIsoCode.ID]: `Индонезия `,
  [PrizmCountryIsoCode.IE]: `Ирландия`,
  [PrizmCountryIsoCode.IL]: `Израиль`,
  [PrizmCountryIsoCode.IN]: `Индия`,
  [PrizmCountryIsoCode.IQ]: `Ирак`,
  [PrizmCountryIsoCode.IR]: `Иран`,
  [PrizmCountryIsoCode.IS]: `Исландия`,
  [PrizmCountryIsoCode.IT]: `Италия`,
  [PrizmCountryIsoCode.JM]: `Ямайка`,
  [PrizmCountryIsoCode.JO]: `Иордания`,
  [PrizmCountryIsoCode.JP]: `Япония `,
  [PrizmCountryIsoCode.KE]: `Кения`,
  [PrizmCountryIsoCode.KG]: `Киргизия`,
  [PrizmCountryIsoCode.KH]: `Камбоджа`,
  [PrizmCountryIsoCode.KM]: `Коморы`,
  [PrizmCountryIsoCode.KN]: `Сент-Китс и Невис`,
  [PrizmCountryIsoCode.KP]: `Корейская НДР`,
  [PrizmCountryIsoCode.KR]: `Респ. Корея`,
  [PrizmCountryIsoCode.KW]: `Кувейт`,
  [PrizmCountryIsoCode.KY]: `Каймановы острова`,
  [PrizmCountryIsoCode.KZ]: `Казахстан`,
  [PrizmCountryIsoCode.LA]: `Лаос`,
  [PrizmCountryIsoCode.LB]: `Ливан `,
  [PrizmCountryIsoCode.LC]: `Сент-Люсия`,
  [PrizmCountryIsoCode.LI]: `Лихтенштейн`,
  [PrizmCountryIsoCode.LK]: `Шри-Ланка`,
  [PrizmCountryIsoCode.LR]: `Либерия`,
  [PrizmCountryIsoCode.LS]: `Лесото`,
  [PrizmCountryIsoCode.LT]: `Литва`,
  [PrizmCountryIsoCode.LU]: `Люксембург`,
  [PrizmCountryIsoCode.LV]: `Латвия`,
  [PrizmCountryIsoCode.LY]: `Ливия`,
  [PrizmCountryIsoCode.MA]: `Марокко`,
  [PrizmCountryIsoCode.MC]: `Монако`,
  [PrizmCountryIsoCode.MD]: `Молдова`,
  [PrizmCountryIsoCode.ME]: `Черногория`,
  [PrizmCountryIsoCode.MG]: `Мадагаскар`,
  [PrizmCountryIsoCode.MK]: `Респ. Северная Македония`,
  [PrizmCountryIsoCode.ML]: `Мали`,
  [PrizmCountryIsoCode.MM]: `Бирма (Мьянма)`,
  [PrizmCountryIsoCode.MN]: `Монголия`,
  [PrizmCountryIsoCode.MO]: `Макао`,
  [PrizmCountryIsoCode.MR]: `Мавритания`,
  [PrizmCountryIsoCode.MS]: `Монтсеррат`,
  [PrizmCountryIsoCode.MT]: `Мальта`,
  [PrizmCountryIsoCode.MU]: `Маврикий`,
  [PrizmCountryIsoCode.MV]: `Мальдивские острова`,
  [PrizmCountryIsoCode.MW]: `Малави`,
  [PrizmCountryIsoCode.MX]: `Мексика`,
  [PrizmCountryIsoCode.MY]: `Малайзия`,
  [PrizmCountryIsoCode.MZ]: `Мозамбик`,
  [PrizmCountryIsoCode.NA]: `Намибия`,
  [PrizmCountryIsoCode.NE]: `Нигер`,
  [PrizmCountryIsoCode.NG]: `Нигерия`,
  [PrizmCountryIsoCode.NI]: `Никарагуа`,
  [PrizmCountryIsoCode.NL]: `Нидерланды`,
  [PrizmCountryIsoCode.NO]: `Норвегия`,
  [PrizmCountryIsoCode.NP]: `Непал`,
  [PrizmCountryIsoCode.NZ]: `Новая Зеландия`,
  [PrizmCountryIsoCode.OM]: `Оман`,
  [PrizmCountryIsoCode.PA]: `Панама`,
  [PrizmCountryIsoCode.PE]: `Перу`,
  [PrizmCountryIsoCode.PF]: `Французская Полинезия (Таити)`,
  [PrizmCountryIsoCode.PG]: `Папуа-Новая Гвинея`,
  [PrizmCountryIsoCode.PH]: `Филиппины`,
  [PrizmCountryIsoCode.PK]: `Пакистан`,
  [PrizmCountryIsoCode.PL]: `Польша`,
  [PrizmCountryIsoCode.PT]: `Португалия`,
  [PrizmCountryIsoCode.PW]: `Палау`,
  [PrizmCountryIsoCode.PY]: `Парагвай`,
  [PrizmCountryIsoCode.QA]: `Катар`,
  [PrizmCountryIsoCode.RO]: `Румыния`,
  [PrizmCountryIsoCode.RS]: `Сербия`,
  [PrizmCountryIsoCode.RU]: `Россия`,
  [PrizmCountryIsoCode.RW]: `Руанда`,
  [PrizmCountryIsoCode.SA]: `Саудовская Аравия `,
  [PrizmCountryIsoCode.SB]: `Соломоновы Острова `,
  [PrizmCountryIsoCode.SC]: `Сейшелы`,
  [PrizmCountryIsoCode.SD]: `Судан`,
  [PrizmCountryIsoCode.SE]: `Швеция`,
  [PrizmCountryIsoCode.SG]: `Сингапур`,
  [PrizmCountryIsoCode.SH]: `Остров Святой Елены`,
  [PrizmCountryIsoCode.SI]: `Словения`,
  [PrizmCountryIsoCode.SK]: `Словакия`,
  [PrizmCountryIsoCode.SL]: `Сьерра-Леоне`,
  [PrizmCountryIsoCode.SM]: `Сан-Марино`,
  [PrizmCountryIsoCode.SN]: `Сенегал`,
  [PrizmCountryIsoCode.SO]: `Сомали`,
  [PrizmCountryIsoCode.SR]: `Суринам `,
  [PrizmCountryIsoCode.ST]: `Сан-Томе и Принсипи`,
  [PrizmCountryIsoCode.SV]: `Сальвадор`,
  [PrizmCountryIsoCode.SX]: `Синт-Мартен`,
  [PrizmCountryIsoCode.SY]: `Сирийская арабская республика`,
  [PrizmCountryIsoCode.SZ]: `Свазиленд`,
  [PrizmCountryIsoCode.TC]: `Тёркс и Кайкос`,
  [PrizmCountryIsoCode.TD]: `Чад`,
  [PrizmCountryIsoCode.TG]: `Того`,
  [PrizmCountryIsoCode.TH]: `Таиланд `,
  [PrizmCountryIsoCode.TJ]: `Таджикистан`,
  [PrizmCountryIsoCode.TL]: `Восточный Тимор`,
  [PrizmCountryIsoCode.TM]: `Туркменистан`,
  [PrizmCountryIsoCode.TN]: `Тунис`,
  [PrizmCountryIsoCode.TO]: `Тонга`,
  [PrizmCountryIsoCode.TR]: `Турция`,
  [PrizmCountryIsoCode.TT]: `Тринидад и Тобаго`,
  [PrizmCountryIsoCode.TW]: `Тайвань`,
  [PrizmCountryIsoCode.TZ]: `Танзания`,
  [PrizmCountryIsoCode.UA]: `Украина`,
  [PrizmCountryIsoCode.UG]: `Уганда`,
  [PrizmCountryIsoCode.US]: `США`,
  [PrizmCountryIsoCode.UY]: `Уругвай`,
  [PrizmCountryIsoCode.UZ]: `Узбекистан`,
  [PrizmCountryIsoCode.VC]: `Сент-Винсент и Гренадины`,
  [PrizmCountryIsoCode.VE]: `Венесуэла`,
  [PrizmCountryIsoCode.VG]: `Британские Виргинские острова`,
  [PrizmCountryIsoCode.VN]: `Вьетнам`,
  [PrizmCountryIsoCode.VU]: `Вануату `,
  [PrizmCountryIsoCode.WS]: `Самоа`,
  [PrizmCountryIsoCode.YE]: `Йемен `,
  [PrizmCountryIsoCode.ZA]: `Южно-Африканская Респ.`,
  [PrizmCountryIsoCode.ZM]: `Замбия`,
  [PrizmCountryIsoCode.ZW]: `Зимбабве`,
  [PrizmCountryIsoCode.XK]: `Республика Косово`,
};
